// extracted by mini-css-extract-plugin
module.exports = {"root":"N1j85dwk"};